<template>
  <b-carousel class="detection-images" :controls="item.files.length > 1" :indicators="item.files.length > 1"
    img-width="300" img-height="300" background="#ababab" style="text-shadow: 1px 1px 2px #000;" :interval="0">
    <b-carousel-slide v-for="file in item.files" :key="file.id">
      <template #img>
        <LOSPreviewSvg :info="{ ...item, files: [file] }" />
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import LOSPreviewSvg from '../LabelObjectSets/LOSPreviewSvg.vue';

export default {
  components: {
    LOSPreviewSvg
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.detection-images {
  max-width: 300px;

  .carousel-control-prev,
  .carousel-control-next {
    top: 50%;
    margin: -20px 0 0;
    background: #333;
    height: 40px;
    width: 40px;
  }
}

.carousel-indicators li {
  width: 6px;
  height: 6px;
  border-radius: 100%;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.5);
  border: none
}
</style>
